import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-prism-sharp",
  "use": "icon-prism-sharp-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" class=\"ionicon\" viewBox=\"0 0 512 512\" id=\"icon-prism-sharp\"><title>Prism</title><path d=\"M256 16L16 352l240 144 240-144zm-20 96.82v324.53L73.73 340z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol